import { Component, Injector } from '@angular/core';
import { AppFormComponent } from 'src/app/components/tuain/forms/app-form.component';
import { PosInterfaceService } from 'src/app/services/pos-interface.service';

const frm = {
  name: 'cashierDevice',
  states: { deviceInfo: 'deviceInfo' },
  sections: { deviceInfo: 'deviceInfo' },
  subsections: { deviceInfo: 'deviceInfo' },
  fields: {
    terminalPosSerial: 'terminalPosSerial',
    terminalSerial: 'terminalSerial',
    terminalType: 'terminalType',
    terminalBrand: 'terminalBrand',
    terminalModel: 'terminalModel',
    userType: 'userType',
  },
  actions: { getTerminalDetail: 'getTerminalDetail' },
};

const AGENT = ['agent', 'agentAdmin'];

@Component({
  selector: 'app-topbar-terminal',
  templateUrl: './terminal.component.html',
})
export class TerminalComponentForm extends AppFormComponent {
  private _posInterface: PosInterfaceService;
  serviceEnabled: boolean = false;
  terminalFound: boolean = false;
  detailVisible: boolean = false;
  terminalErrMessage: string = '';
  terminalPosSerial: string;
  terminalSerial: string;
  terminalType: string;
  terminalBrand: string;
  terminalModel: string;
  portNumber: number;
  formerPortNumber: number = 0;
  activeIcon = true;

  constructor(injector: Injector) {
    super(injector);
    this._posInterface = injector.get(PosInterfaceService);
    this.formerPortNumber = this._posInterface.defaultPortNumber;
  }

  override customPreProcessing() {
    this.formCode = frm.name;
  }

  override customFormStart() {
    this.onActionStart(frm.actions.getTerminalDetail, this.getTerminalDetailPre.bind(this));
    this.onActionFinish(frm.actions.getTerminalDetail, this.getTerminalDetailPost.bind(this));
    this.startAction(frm.actions.getTerminalDetail);
    this.validateUser();
  }

  async getTerminalDetailPre() {
    this.serviceEnabled = false;
    this.terminalSerial = '';
    this.terminalType = '';
    this.terminalBrand = '';
    this.terminalModel = '';
    this.formerPortNumber = this._posInterface.defaultPortNumber;
    this.portNumber = this.formerPortNumber;
    const { terminals } = this._userSession.getSessionData() ?? {};
    this.terminalFound = false;
    const { error, data } = await this._posInterface.getDeviceSerial();
    if (error) {
      this.terminalErrMessage = 'Sin acceso a servicio';
      return false;
    }
    this.serviceEnabled = true;
    this.terminalPosSerial = data?.serie;
    if (!this.terminalPosSerial) {
      this.terminalErrMessage = 'Servicio no conectado a dispositivo';
      return false;
    }
    this.terminalFound = terminals?.find(serial => serial.includes(this.terminalPosSerial));
    if (!this.terminalFound) {
      this.terminalErrMessage = 'Dispositivo no autorizado';
      return false;
    }
    this.terminalErrMessage = '';
    this.setFieldValue(frm.fields.terminalPosSerial, this.terminalPosSerial);
    return true;
  }

  getTerminalDetailPost() {
    this.terminalSerial = this.getFieldValue(frm.fields.terminalSerial);
    this.terminalType = this.getFieldValue(frm.fields.terminalType);
    this.terminalBrand = this.getFieldValue(frm.fields.terminalBrand);
    this.terminalModel = this.getFieldValue(frm.fields.terminalModel);
    this._posInterface.setRemoteSerial(this.terminalSerial);
  }

  async changeDevicePort() {
    if (+this.portNumber > 0 && this.portNumber !== this.formerPortNumber) {
      this.formerPortNumber = this.portNumber;
      await this._posInterface.setSerialPort(this.portNumber);
      this.startAction(frm.actions.getTerminalDetail);
    }
  }

  closeDetail() {
    if (!this.detailVisible) {
      this.portNumber = this.formerPortNumber;
    }
    this.detailVisible = false;
  }

  deviceChange(value: boolean): void { }

  validateUser() {
    const userType = this.getFieldValue(frm.fields.userType);
    if (AGENT.includes(userType)) {
      this.activeIcon = false;
    } else {
      this.activeIcon = true;
    }

  }

  async reloadData() {
    await this._posInterface.initPosService();
    this.startAction(frm.actions.getTerminalDetail);
  }
}
